import React, { useState } from 'react';
import Button from '../../../../../../components/Button';
import DragSortTable from '../../../../../../components/table/DragSortTable';
import { EventItemV2 } from '../../../../../../types/event';
import eventColumns from './eventColumns';
import { reOrderArray } from '../../../../../../lib/common';
import EventWidgetPreviewModal from './EventWidgetPreviewModal';
import { DateRageType } from '../../../../../../types/common/date';
import { EventWidgetListTableHeader, EventWidgetListTableStyle } from './style';
import { WidgetItemEvent } from '../../../../../../types/widget';

export type EventItemWithPeriod = EventItemV2 & { exposurePeriod: DateRageType; itemId: number };

interface EventWidgetListTableProps {
  list: EventItemWithPeriod[];
  widgetItemList: Partial<WidgetItemEvent>[];
  onDragEnd: (list: EventItemWithPeriod[]) => void;
}

const EventWidgetListTable = (props: EventWidgetListTableProps): JSX.Element => {
  const { list, onDragEnd, widgetItemList } = props;

  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);

  const handleClickPreview = (): void => setIsPreviewModalOpen(true);

  const handleDragEnd = (result: { source: { index: number }; destination: { index: number } }): void => {
    const { source, destination } = result;

    if (!source || !destination) return;

    /**
     *  변경될 아이템 이동시키기
     */
    const newList = reOrderArray(list, source.index, destination.index);

    onDragEnd(newList);
  };

  return (
    <EventWidgetListTableStyle>
      <EventWidgetListTableHeader>
        <Button isRadius text="미리보기" color="primary" type="button" onClick={handleClickPreview} />
      </EventWidgetListTableHeader>

      <DragSortTable
        isDragDisabled={list.length === 1}
        emptyText="위젯에 노출중인 기획전이 없습니다."
        onDragEnd={handleDragEnd}
        showPagination={false}
        columns={eventColumns}
        data={list}
        list={list}
      />
      {isPreviewModalOpen && (
        <EventWidgetPreviewModal closeModal={(): void => setIsPreviewModalOpen(false)} list={widgetItemList} />
      )}
    </EventWidgetListTableStyle>
  );
};

export default EventWidgetListTable;
